import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GenesysContactDisplayNameComponent } from './genesys-contact-display-name.component';
import { TranslateModule } from '@ngx-translate/core';
import { GenesysContactDisplayNamePipe } from './pipes/genesys-contact-display-name.pipe';

@NgModule({
  declarations: [
    GenesysContactDisplayNameComponent,
    GenesysContactDisplayNamePipe
  ],
  imports: [
    CommonModule,
    TranslateModule
  ],
  exports: [
    GenesysContactDisplayNameComponent,
    GenesysContactDisplayNamePipe
  ]
})
export class GenesysContactDisplayNameModule { }
